export const RELATED_BLOGS_LOADER = "RELATED_BLOGS_LOADER";
export const RELATED_BLOGS_SUCCESS = "RELATED_BLOGS_SUCCESS";
export const RELATED_BLOGS_FAILURE = "RELATED_BLOGS_FAILURE";
export const RELATED_BLOGS_RESET = "RELATED_BLOGS_RESET";